const comments = [
  {
    id: 1,
    name: '光影捕手',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20avatar%20portrait%20of%20a%20person%2C%20warm%20tones%2C%20soft%20lighting%2C%20circular%20frame%2C%20clean%20background%2C%20friendly%20expression&width=100&height=100&seq=avatar-user-01&orientation=squarish',
    date: '2025-07-28',
    rating: 5,
    content:
      '用了窝窝影院快一年了，真心推荐！资源更新速度非常快，基本上热播剧当天就能看到最新集。画质清晰流畅，最重要的是真的没有广告，观影体验很纯粹。已经推荐给了身边所有喜欢追剧的朋友。',
  },
  {
    id: 2,
    name: '剧荒终结者',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20avatar%20portrait%20of%20a%20person%2C%20warm%20neutral%20tones%2C%20soft%20lighting%2C%20circular%20frame%2C%20clean%20background&width=100&height=100&seq=avatar-user-02&orientation=squarish',
    date: '2025-07-25',
    rating: 5,
    content:
      '作为一个重度影视爱好者，窝窝影院的资源丰富程度让我惊喜。从国产剧到欧美大片，从动漫到纪录片，品类齐全。免费高清这个点太良心了，不用开任何会员就能享受这么好的观影体验，给一万个赞！',
  },
  {
    id: 3,
    name: '深夜放映室',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20avatar%20portrait%20of%20a%20person%2C%20warm%20earthy%20tones%2C%20soft%20lighting%2C%20circular%20frame%2C%20clean%20background%2C%20gentle%20expression&width=100&height=100&seq=avatar-user-03&orientation=squarish',
    date: '2025-07-22',
    rating: 4,
    content:
      '之前用了好几个类似的平台，要么广告多到烦，要么经常缓冲卡顿。窝窝影院是我目前体验最好的免费影视站，加载速度快，画质也不错。希望能一直这样保持下去，不要变质。',
  },
  {
    id: 4,
    name: '追剧小达人',
    avatar: 'https://readdy.ai/api/search-image?query=Simple%20minimalist%20avatar%20portrait%20of%20a%20person%2C%20warm%20golden%20tones%2C%20soft%20lighting%2C%20circular%20frame%2C%20clean%20background%2C%20playful%20expression&width=100&height=100&seq=avatar-user-04&orientation=squarish',
    date: '2025-07-20',
    rating: 5,
    content:
      '妈妈再也不用担心我剧荒了！窝窝影院的片库实在太全了，而且分类清晰，找片非常方便。手机上看也很流畅，通勤路上追剧神器。免费、高清、无广告，这三个词完美概括了我的使用感受。',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium tracking-wide mb-3">
            口碑
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            用户评价
          </h2>
          <p className="text-foreground-500 text-sm md:text-base mt-2 max-w-lg mx-auto">
            来自真实用户的使用反馈与推荐
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {comments.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-50 rounded-xl border border-background-200/70 p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="font-medium text-sm text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.date}</div>
                </div>
                <div className="flex items-center gap-0.5">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <div key={i} className="w-4 h-4 flex items-center justify-center">
                      <i
                        className={`text-xs ${
                          i < comment.rating ? 'ri-star-fill text-accent-500' : 'ri-star-line text-foreground-300'
                        }`}
                      ></i>
                    </div>
                  ))}
                </div>
              </div>
              <p className="text-foreground-600 text-sm leading-relaxed">{comment.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}